const options = [
    'Foster a Vibrant and Inclusive Campus Experience for All',
    'Support Innovation and Interdisciplinary Collaboration',
    'Become a More Resilient, Responsive, and Sustainable Campus',
    'Contribute to a Diverse and Beautiful Campus Setting',
    'Become a More Intuitive and Connected Campus',
    'Leverage Efficient and Strategic Use of Resources',
];
const importantElements = [];
options.forEach((v, i) => {
    importantElements.push({id: `imp_${i + 1}`, name: v});
});
export default importantElements;
